import {
  ExternalRouteRef,
  RouteRef,
  SubRouteRef,
  createExternalRouteRef,
  createSubRouteRef,
} from '@backstage/core-plugin-api';

import { createPageRoute } from '@spotify/confidence-common-react';

export enum RoutesIds {
  initiatives = 'initiatives',
  initiative = 'initiative',
  initiativeSettings = 'initiativeSettings',
}

enum ExternalRoutesIds {
  experimentationPlatformInitiative = 'experimentationPlatformInitiative',
  project = 'project',
  chat = 'chat',
  projectChat = 'projectChat',
}

// root route
export const initiativesRouteRef = createPageRoute({
  id: 'initiative-index',
  page: { title: 'Initiatives' },
});

export const rootRouteRef = initiativesRouteRef;

// sub-routes within the plugin
export const initiativeRouteRef = createPageRoute({
  id: RoutesIds.initiative,
  route: { parent: rootRouteRef, path: '/:id' },
  page: { title: 'Initiative', defaultTab: 'Overview' },
});

export const initiativeExperimentsRouteRef = createPageRoute({
  id: 'initiative-experiments',
  route: { parent: initiativeRouteRef, path: '/:id/experiments' },
  page: { title: 'Experiments' },
});

export const initiativeProjectsRouteRef = createPageRoute({
  id: 'initiative-projects',
  route: { parent: initiativeRouteRef, path: '/:id/projects' },
  page: { title: 'Projects' },
});

export const initiativeSettingsRouteRef = createSubRouteRef({
  id: RoutesIds.initiativeSettings,
  parent: rootRouteRef,
  path: '/:id/settings',
});

// external routes to other systems (for backward compatibility during migration)
export const experimentationPlatformInitiativeRouteRef = createExternalRouteRef(
  {
    id: 'backstage-experimentation-platform-initiative',
    params: ['id'],
    optional: true,
  },
);

export const projectRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.project,
  params: ['id'],
  optional: true,
});

export const chatRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.chat,
  params: ['id'],
  optional: true,
});

export const projectChatRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.projectChat,
  params: ['id', 'chatId'],
  optional: true,
});

// default routes/routes to be used by other plugins
export const Routes = {
  initiatives: initiativesRouteRef,
  initiative: initiativeRouteRef,
  initiativeSettings: initiativeSettingsRouteRef,
} satisfies Record<RoutesIds, SubRouteRef | RouteRef>;

export const ExternalRoutes = {
  // external routes to other systems
  experimentationPlatformInitiative: experimentationPlatformInitiativeRouteRef,
  project: projectRouteRef,
  chat: chatRouteRef,
  projectChat: projectChatRouteRef,
} satisfies Record<ExternalRoutesIds, ExternalRouteRef>;
